/**
 * Показывать ли окно-приглашение колеса фортуны при входе (задача владельца
 * 2026-10-21: «юзеру, который вошёл в приложение первый раз, показывать окно
 * уведомления о колесе не нужно — чтобы оно не пересекалось с приглашением
 * создать пробного бота, главное, чтобы юзер создал бота»).
 *
 * Правило: приглашение колеса молчит, пока юзера ждёт пробный бот — то есть
 * пока у него нет подписки и либо ботов нет совсем (онбординг-флоу первого
 * входа и карточка «Создать пробного бота» на Дашборде), либо есть только
 * пробный виртуальный бот (TrialStatusCard на Дашборде). Как только бот создан
 * и юзер купил подписку (или триал закончился) — окно снова можно показывать.
 *
 * При этом день помечается просмотренным (`suppress`): иначе окно выскочило бы
 * позже в тот же день — сразу после создания пробного бота или оформления
 * подписки — и перекрыло бы экран, где юзеру нужно сделать следующий шаг.
 *
 * Плавающая кнопка колеса у края экрана (FortuneFab) работает всегда: юзер,
 * который сам ищет розыгрыш, его найдёт и без окна.
 *
 * Чистая функция без побочных эффектов: таблицу истинности по всем входам
 * прогоняет харнесс проверок батча.
 *
 * Возвращает:
 *   'off'      — функция выключена (или выключено само окно) — ничего не делать;
 *   'wait'     — профиль/боты ещё грузятся: не показывать И НЕ помечать день,
 *                решение примем, когда данные придут;
 *   'seen'     — окно уже показывали сегодня;
 *   'suppress' — новичок ждёт пробного бота: не показывать, день пометить;
 *   'show'     — показывать окно.
 */
export function fortuneIntroDecision({
  enabled,
  introEnabled,
  ready,
  suppressIntro,
  seenToday,
}) {
  if (!enabled || !introEnabled) return 'off'
  // Данные ещё не пришли: если показать сейчас, «пустой» список ботов на первом
  // кадре выглядел бы как новичок — а он мог и не быть новичком. Ждём.
  if (!ready) return 'wait'
  if (seenToday) return 'seen'
  if (suppressIntro) return 'suppress'
  return 'show'
}

/**
 * Ждёт ли юзера пробный бот — то есть стоит ли придержать приглашение колеса.
 *
 * Да, когда профиль и список ботов уже пришли с сервера, юзер не админ, у него
 * нет активной подписки и при этом либо ботов нет совсем (онбординг-флоу
 * первого входа и карточка «Создать пробного бота» на Дашборде), либо есть
 * только пробный виртуальный бот (TrialStatusCard).
 *
 * Нет — для админа (он проверяет колесо сам) и для юзера с подпиской или с
 * обычным ботом: приглашения создать пробного бота у них на экране нет.
 */
export function trialBotPending({
  profileOk,
  botsLoaded,
  isAdmin,
  demoAllowed,
  realAllowed,
  userBots,
}) {
  if (!profileOk || !botsLoaded || isAdmin || demoAllowed || realAllowed) return false
  if (!Array.isArray(userBots) || userBots.length === 0) return true
  return userBots.some(b => b && b.virtual)
}
